(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-page-2"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', e =>
{
  setupContentTextSections2();
  setupSlider2();
});

function setupContentTextSections2()
{
  var titles = document.querySelectorAll('#cp-2 .content-page-text-section-title');
  titles.forEach(title =>
  {
    initTextSection2(title);
    title.addEventListener('click', e =>
    {
      toggleTextSection2(e.target);
    });
  });
}

function initTextSection2(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-2 .content-page-text-section-text');
  textSectionText.style.display = "none";
}

function toggleTextSection2(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-2 .content-page-text-section-text');
  if (textSectionText.style.display === "none") {
    textSectionText.style.display = "block";
    title.classList.add('open');
  } else {
    textSectionText.style.display = "none";
    title.classList.remove('open');
  }
}
 
var slides2;
let activeSlideNo2 = 0;
let noSlides2 = 0;

function setupSlider2()
{
	slides2 = document.querySelectorAll('#cp-2 .content-gallery-slide');
	noSlides2 = slides2.length;

	if (noSlides2 == 0)
	{
		return;
	}
  

	// show active slide
	slides2[activeSlideNo2].style.display = 'block';

	// set up click handlers
	document.querySelector('#cp-2 .content-gallery-slide-arrow.left').addEventListener('click', event => {
	  // left slider clicked
	  clickSlider2('left');
    });

	document.querySelector('#cp-2 .content-gallery-slide-arrow.right').addEventListener('click', event => {
	  // right slider clicked
	  clickSlider2('right');
    });
}

function clickSlider2(direction)
{
	var oldActiveSlideNo2 = activeSlideNo2;

	if (direction == 'left')
	{
		activeSlideNo2 = activeSlideNo2 - 1;
		if (activeSlideNo2 == -1)
		{
			activeSlideNo2 = noSlides2 - 1;
		}
	}
	else
	{
		activeSlideNo2 = activeSlideNo2 + 1;
		if (activeSlideNo2 == noSlides2)
		{
			activeSlideNo2 = 0;
		}
	}

	slides2[oldActiveSlideNo2].style.display = 'none';
	slides2[activeSlideNo2].style.display = 'block';

  var oldActiveDotNo2 = oldActiveSlideNo2 + 1;
  var activeDotNo2 = activeSlideNo2 + 1;
  $('#cp-2 .content-gallery-dots .dot:nth-child('+oldActiveDotNo2+')').removeClass('active');
  $('#cp-2 .content-gallery-dots .dot:nth-child('+activeDotNo2+')').addClass('active');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-page-3"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', e =>
{
  setupContentTextSections3();
  setupSlider3();
});

function setupContentTextSections3()
{
  var titles = document.querySelectorAll('#cp-3 .content-page-text-section-title');
  titles.forEach(title =>
  {
    initTextSection3(title);
    title.addEventListener('click', e =>
    {
      toggleTextSection3(e.target);
    });
  });
}

function initTextSection3(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-3 .content-page-text-section-text');
  textSectionText.style.display = "none";
}

function toggleTextSection3(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-3 .content-page-text-section-text');
  if (textSectionText.style.display === "none") {
    textSectionText.style.display = "block";
    title.classList.add('open');
  } else {
    textSectionText.style.display = "none";
    title.classList.remove('open');
  }
}
 
var slides3;
let activeSlideNo3 = 0;
let noSlides3 = 0;

function setupSlider3()
{
	slides3 = document.querySelectorAll('#cp-3 .content-gallery-slide');
	noSlides3 = slides3.length;

	if (noSlides3 == 0)
	{
		return;
	}
  

	// show active slide
	slides3[activeSlideNo3].style.display = 'block';

	// set up click handlers
	document.querySelector('#cp-3 .content-gallery-slide-arrow.left').addEventListener('click', event => {
	  // left slider clicked
	  clickSlider3('left');
    });

	document.querySelector('#cp-3 .content-gallery-slide-arrow.right').addEventListener('click', event => {
	  // right slider clicked
	  clickSlider3('right');
    });
}

function clickSlider3(direction)
{
	var oldActiveSlideNo3 = activeSlideNo3;

	if (direction == 'left')
	{
		activeSlideNo3 = activeSlideNo3 - 1;
		if (activeSlideNo3 == -1)
		{
			activeSlideNo3 = noSlides3 - 1;
		}
	}
	else
	{
		activeSlideNo3 = activeSlideNo3 + 1;
		if (activeSlideNo3 == noSlides3)
		{
			activeSlideNo3 = 0;
		}
	}

	slides3[oldActiveSlideNo3].style.display = 'none';
	slides3[activeSlideNo3].style.display = 'block';

  var oldActiveDotNo3 = oldActiveSlideNo3 + 1;
  var activeDotNo3 = activeSlideNo3 + 1;
  $('#cp-3 .content-gallery-dots .dot:nth-child('+oldActiveDotNo3+')').removeClass('active');
  $('#cp-3 .content-gallery-dots .dot:nth-child('+activeDotNo3+')').addClass('active');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-page-4"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', e =>
{
  setupContentTextSections4();
  setupSlider4();
});

function setupContentTextSections4()
{
  var titles = document.querySelectorAll('#cp-4 .content-page-text-section-title');
  titles.forEach(title =>
  {
    initTextSection4(title);
    title.addEventListener('click', e =>
    {
      toggleTextSection4(e.target);
    });
  });
}

function initTextSection4(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-4 .content-page-text-section-text');
  textSectionText.style.display = "none";
}

function toggleTextSection4(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-4 .content-page-text-section-text');
  if (textSectionText.style.display === "none") {
    textSectionText.style.display = "block";
    title.classList.add('open');
  } else {
    textSectionText.style.display = "none";
    title.classList.remove('open');
  }
}
 
var slides4;
let activeSlideNo4 = 0;
let noSlides4 = 0;

function setupSlider4()
{
	slides4 = document.querySelectorAll('#cp-4 .content-gallery-slide');
	noSlides4 = slides4.length;

	if (noSlides4 == 0)
	{
		return;
	}
  

	// show active slide
	slides4[activeSlideNo4].style.display = 'block';

	// set up click handlers
	document.querySelector('#cp-4 .content-gallery-slide-arrow.left').addEventListener('click', event => {
	  // left slider clicked
	  clickSlider4('left');
    });

	document.querySelector('#cp-4 .content-gallery-slide-arrow.right').addEventListener('click', event => {
	  // right slider clicked
	  clickSlider4('right');
    });
}

function clickSlider4(direction)
{
	var oldActiveSlideNo4 = activeSlideNo4;

	if (direction == 'left')
	{
		activeSlideNo4 = activeSlideNo4 - 1;
		if (activeSlideNo4 == -1)
		{
			activeSlideNo4 = noSlides4 - 1;
		}
	}
	else
	{
		activeSlideNo4 = activeSlideNo4 + 1;
		if (activeSlideNo4 == noSlides4)
		{
			activeSlideNo4 = 0;
		}
	}

	slides4[oldActiveSlideNo4].style.display = 'none';
	slides4[activeSlideNo4].style.display = 'block';

  var oldActiveDotNo4 = oldActiveSlideNo4 + 1;
  var activeDotNo4 = activeSlideNo4 + 1;
  $('#cp-4 .content-gallery-dots .dot:nth-child('+oldActiveDotNo4+')').removeClass('active');
  $('#cp-4 .content-gallery-dots .dot:nth-child('+activeDotNo4+')').addClass('active');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-page-video"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', e =>
{
  setupContentTextSections();
  setupSlider();
});

function setupContentTextSections()
{
  var titles = document.querySelectorAll('#cp-video .content-page-text-section-title');
  titles.forEach(title =>
  {
    initTextSection(title);
    title.addEventListener('click', e =>
    {
      toggleTextSection(e.target);
    });
  });
}

function initTextSection(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-video .content-page-text-section-text');
  textSectionText.style.display = "none";
}

function toggleTextSection(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-video .content-page-text-section-text');
  if (textSectionText.style.display === "none") {
    textSectionText.style.display = "block";
    title.classList.add('open');
  } else {
    textSectionText.style.display = "none";
    title.classList.remove('open');
  }
}

var slides;
let activeSlideNo = 0;
let noSlides = 0;

function setupSlider()
{
	slides = document.querySelectorAll('#cp-video .content-gallery-slide');
	noSlides = slides.length;

	if (noSlides == 0)
	{
		return;
	}
  

	// show active slide
	slides[activeSlideNo].style.display = 'block';

	// set up click handlers
	document.querySelector('#cp-video .content-gallery-slide-arrow.left').addEventListener('click', event => {
	  // left slider clicked
	  clickSlider('left');
    });

	document.querySelector('#cp-video .content-gallery-slide-arrow.right').addEventListener('click', event => {
	  // right slider clicked
	  clickSlider('right');
    });
}

function clickSlider(direction)
{
	var oldActiveSlideNo = activeSlideNo;

	if (direction == 'left')
	{
		activeSlideNo = activeSlideNo - 1;
		if (activeSlideNo == -1)
		{
			activeSlideNo = noSlides - 1;
		}
	}
	else
	{
		activeSlideNo = activeSlideNo + 1;
		if (activeSlideNo == noSlides)
		{
			activeSlideNo = 0;
		}
	}

	slides[oldActiveSlideNo].style.display = 'none';
	slides[activeSlideNo].style.display = 'block';

  var oldActiveDotNo = oldActiveSlideNo + 1;
  var activeDotNo = activeSlideNo + 1;
  $('#cp-video .content-gallery-dots .dot:nth-child('+oldActiveDotNo+')').removeClass('active');
  $('#cp-video .content-gallery-dots .dot:nth-child('+activeDotNo+')').addClass('active');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-page"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', e =>
{
  setupContentTextSections();
  setupSlider();
});

function setupContentTextSections()
{
  var titles = document.querySelectorAll('#cp-video .content-page-text-section-title');
  titles.forEach(title =>
  {
    initTextSection(title);
    title.addEventListener('click', e =>
    {
      toggleTextSection(e.target);
    });
  });
}

function initTextSection(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-video .content-page-text-section-text');
  textSectionText.style.display = "none";
}

function toggleTextSection(title)
{
  var textSection = title.parentElement;
  var textSectionText = textSection.querySelector('#cp-video .content-page-text-section-text');
  if (textSectionText.style.display === "none") {
    textSectionText.style.display = "block";
    title.classList.add('open');
  } else {
    textSectionText.style.display = "none";
    title.classList.remove('open');
  }
}

var slides;
let activeSlideNo = 0;
let noSlides = 0;

function setupSlider()
{
	slides = document.querySelectorAll('#cp-video .content-gallery-slide');
	noSlides = slides.length;

	if (noSlides == 0)
	{
		return;
	}
  

	// show active slide
	slides[activeSlideNo].style.display = 'block';

	// set up click handlers
	document.querySelector('#cp-video .content-gallery-slide-arrow.left').addEventListener('click', event => {
	  // left slider clicked
	  clickSlider('left');
    });

	document.querySelector('#cp-video .content-gallery-slide-arrow.right').addEventListener('click', event => {
	  // right slider clicked
	  clickSlider('right');
    });
}

function clickSlider(direction)
{
	var oldActiveSlideNo = activeSlideNo;

	if (direction == 'left')
	{
		activeSlideNo = activeSlideNo - 1;
		if (activeSlideNo == -1)
		{
			activeSlideNo = noSlides - 1;
		}
	}
	else
	{
		activeSlideNo = activeSlideNo + 1;
		if (activeSlideNo == noSlides)
		{
			activeSlideNo = 0;
		}
	}

	slides[oldActiveSlideNo].style.display = 'none';
	slides[activeSlideNo].style.display = 'block';

  var oldActiveDotNo = oldActiveSlideNo + 1;
  var activeDotNo = activeSlideNo + 1;
  $('#cp-video .content-gallery-dots .dot:nth-child('+oldActiveDotNo+')').removeClass('active');
  $('#cp-video .content-gallery-dots .dot:nth-child('+activeDotNo+')').addClass('active');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spots"] && !window.DesignMode) return;
  try {
    

window.addEventListener('load', e =>
{
  setupHover();
});

function setupHover()
{
  var spots = document.querySelectorAll('.spot');
  spots.forEach(spot =>
  {
    spot.addEventListener('mouseenter', event => {
      event.target.querySelector('.spot-image-hover').style.display = 'block';
      event.target.querySelector('.spot-image').style.display = 'none';
    });
    spot.addEventListener('mouseleave', event => {
      event.target.querySelector('.spot-image-hover').style.display = 'none';
      event.target.querySelector('.spot-image').style.display = 'block';
    });
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockist_slider"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', e =>
{
  setupStockistSlider();
});

var stockistSlides;
let activeStockistSlideNo = 0;
let noStockistSlides = 0;
var stockistSlider = document.querySelector('.stockist-slides');

function setupStockistSlider()
{
	stockistSlides = document.querySelectorAll('.stockist-slide');
	noStockistSlides = stockistSlides.length - 5;

	if (noStockistSlides == 0)
	{
		return;
	}

    console.log("setup stockist slider", noStockistSlides);

	// set up click handlers
	document.querySelector('.slide-arrow.left').addEventListener('click', event => {
	  // left slider clicked
	  clickStockistSlider('left');
    });

	document.querySelector('.slide-arrow.right').addEventListener('click', event => {
	  // right slider clicked
	  clickStockistSlider('right');
    });
}

function clickStockistSlider(direction)
{
    console.log("click stockist slider", direction, activeStockistSlideNo);
  
	var oldActiveSlideNo = activeStockistSlideNo;

	if (direction == 'left')
	{
		activeStockistSlideNo = activeStockistSlideNo - 1;
		if (activeStockistSlideNo == -1)
		{
			activeStockistSlideNo = noStockistSlides - 1;
		}
	}
	else
	{
		activeStockistSlideNo = activeStockistSlideNo + 1;
		if (activeStockistSlideNo == noStockistSlides)
		{
			activeStockistSlideNo = 0;
		}
	}

    var xTranslation = activeStockistSlideNo * 16;
    stockistSlider.style.transform = 'translateX(-'+xTranslation+'vw)';
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"] && !window.DesignMode) return;
  try {
    

window.addEventListener('load', e =>
{
  console.log('Setup team slider');
  $(".team-nav.nav-left").click(function() {
    moveSlider("l");
  });
  $(".team-nav.nav-right").click(function() {
    moveSlider("r");
  });
  $(".team-nav.nav-left").hide();
  setSwipeBehaviour();
});

var currentSlidePosition = 0;

function moveSlider(direction)
{
  switch(direction)
  {
    case "l":
      currentSlidePosition--;
      currentSlidePosition = Math.max(0, currentSlidePosition);
      console.log('Go left', currentSlidePosition);
      $(".team-nav.nav-right").show();
      if (currentSlidePosition == 0)
      {  
        $(".team-title-text").removeClass("hidden");
        $(".team-nav.nav-left").hide();
      }
      break;
    case "r":
      currentSlidePosition++;
      var maxPosition;
      if (isTeamSliderMobile())
      {
        maxPosition = $('.team-member').length - 1;
      }
      else 
      {
        maxPosition = $('.team-member').length - 2;
      }
      currentSlidePosition = Math.min(currentSlidePosition, maxPosition);
      console.log('Go right', currentSlidePosition);     
      $(".team-title-text").addClass("hidden"); 
      $(".team-nav.nav-left").show();
      if (currentSlidePosition == maxPosition)
      {
        $(".team-nav.nav-right").hide();
      }
      break;
  }
  $('.team-members').css('transform', 'translateX(calc(' + currentSlidePosition + ' * -'  + $(".team-member").width() + 'px))');
}

function isTeamSliderMobile()
{
  return window.innerWidth < 768;
}

function setSwipeBehaviour()
{
  let touchstartX = 0
  let touchendX = 0

  function checkDirection() {
    if (touchendX < touchstartX)
    {
      moveSlider("r");
    }
    else if (touchendX > touchstartX)
    {
      moveSlider("l");
    }
  }

  if ($(".team-members").length > 0)
  {
    $(".team-members")[0].addEventListener('touchstart', e => {
      touchstartX = e.changedTouches[0].screenX
    })

    $(".team-members")[0].addEventListener('touchend', e => {
      touchendX = e.changedTouches[0].screenX
      checkDirection();
    })
  }
}


  } catch(e) { console.error(e); }
})();
})();
